import { AbstractImportFileModel } from "../abstracts";
import { FileType } from "../enums";

/**Модель импортируемого обычного файла */
export class ImportFileModel extends AbstractImportFileModel {
  /**ID загрузки */
  UploadId!: string;
  /**Тип файла */
  readonly Type: FileType = FileType.FILE;

  constructor(data: Partial<ImportFileModel>) {
    super(data);
    Object.assign(this, data);
  }
}
